import { gql } from '@apollo/client';

export const GET_BAG_SHIPMENT_HISTORY = gql`
    query GetBagShipmentHistory($bagNumber: String!) {
        bagShipmentHistory(bagNumber: $bagNumber) {
            id
            kind
            occurredAt
            operatorName
            operatorRole
            warehouseName
            parcelCount
            oldSortingRule
            newSortingRule
            failMessageKey
            originalScanType
            batchName
            sourceBatchName
            isSourceBatchKept
        }
    }
`;

export type BagShipmentNodeKind =
    | 'CREATED'
    | 'DEPARTURE_SCAN'
    | 'BAG_RESHIP'
    | 'LOG_SCAN'
    | 'CURRENT'
    | 'BATCH_MOVE_IN'
    | 'BATCH_MOVE_OUT';

export interface BagShipmentNodeType {
    id: string;
    kind: BagShipmentNodeKind;
    occurredAt: string;
    operatorName: string | null;
    operatorRole: string | null;
    warehouseName: string | null;
    parcelCount: number | null;
    oldSortingRule: string | null;
    newSortingRule: string | null;
    /** 失败原因 i18n key；仅 LOG_SCAN 节点非空 */
    failMessageKey: string | null;
    /** 原本要执行的扫描类型（如 BagReship）；仅 LOG_SCAN 节点非空 */
    originalScanType: string | null;
    /** 批次名：CREATED 为创建时所属批次，BATCH_MOVE_IN 为移入的批次，BATCH_MOVE_OUT 为移出的批次 */
    batchName: string | null;
    /** 来源批次（原批次）；仅 BATCH_MOVE_IN 可能非空 */
    sourceBatchName: string | null;
    /** 上游批次是否仍保留（整包移入）；仅 BATCH_MOVE_IN 非空 */
    isSourceBatchKept: boolean | null;
}

export interface GetBagShipmentHistoryResponse {
    bagShipmentHistory: BagShipmentNodeType[];
}

export interface GetBagShipmentHistoryVariables {
    bagNumber: string;
}
